/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QueryUsageDto } from '../../models/query-usage-dto';

export interface AnalyticsTopQueriesGet$Json$Params {
  take?: number;
}

export function analyticsTopQueriesGet$Json(http: HttpClient, rootUrl: string, params?: AnalyticsTopQueriesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<QueryUsageDto>>> {
  const rb = new RequestBuilder(rootUrl, analyticsTopQueriesGet$Json.PATH, 'get');
  if (params) {
    rb.query('take', params.take, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<QueryUsageDto>>;
    })
  );
}

analyticsTopQueriesGet$Json.PATH = '/analytics/top-queries';
